import { createLabeledMessages, join } from '../../../messageUtils';
const agent = {
    agent: 'sprostredkovateľ',
    mainAgent: join('Hlavný', 'agent:agent'),
    secondaryAgent: join('Druhý', 'agent:agent'),
    agentNumber: 'získateľské číslo',
    agentNumber_short: 'ZČ',
    cnb: 'registrační číslo NBS',
    cnb_short: 'NBS'
};
export default Object.assign({}, agent, createLabeledMessages(agent));
